export default __webpack_public_path__ + "static/media/Handguards of the Savage Fang.b75aaf35.jpg";